import { db } from '../config/firebase';
import { collection, addDoc, query, getDocs, where, orderBy } from 'firebase/firestore';
import { SocialMediaPost } from '../types/facebook';

const COLLECTION_NAME = '8am-facebook-post';

export class SocialMediaPostService {
  async addPost(post: SocialMediaPost): Promise<SocialMediaPost> {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...post,
        createDate: new Date(),
      });
      return { id: docRef.id, ...post };
    } catch (error) {
      throw new Error('Cannot add social media post: ' + error);
    }
  }

  async getAllPosts(): Promise<SocialMediaPost[]> {
    try {
      const querySnapshot = await getDocs(
        query(
          collection(db, COLLECTION_NAME),
          orderBy('createDate', 'desc')
        )
      );
      return querySnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data(),
        createDate: doc.data().createDate.toDate()
      })) as SocialMediaPost[];
    } catch (error) {
      throw new Error('Cannot retrieve social media posts: ' + error);
    }
  }

  async getPostsByType(type: 'facebook' | 'instagram'): Promise<SocialMediaPost[]> {
    try {
      const querySnapshot = await getDocs(
        query(
          collection(db, COLLECTION_NAME),
          where('type', '==', type),
          orderBy('createDate', 'desc')
        )
      );
      return querySnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data(),
        createDate: doc.data().createDate.toDate()
      })) as SocialMediaPost[];
    } catch (error) {
      throw new Error(`Cannot retrieve ${type} posts: ` + error);
    }
  }

  async getPostByPostId(postId: string): Promise<SocialMediaPost | null> {
    try {
      const querySnapshot = await getDocs(
        query(
          collection(db, COLLECTION_NAME),
          where('postId', '==', postId)
        )
      );
      if (querySnapshot.empty) {
        return null;
      }
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
        createDate: doc.data().createDate.toDate()
      } as SocialMediaPost;
    } catch (error) {
      throw new Error('Cannot retrieve post: ' + error);
    }
  }
} 